import * as React from 'react';



export default class WarningMessage extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M9.11788 0.727273C8.62104 -0.242424 7.37896 -0.242425 6.88212 0.727272L0.174862 13.8182C-0.321972 14.7879 0.299069 16 1.29274 16H14.7073C15.7009 16 16.322 14.7879 15.8251 13.8182L9.11788 0.727273ZM8.85455 5L8.56364 10.5081H7.43636L7.14545 5H8.85455ZM9 13.0251C9 13.5391 8.54545 14 8 14C7.45455 14 7 13.5391 7 13.0251C7 12.4934 7.45455 12.0502 8 12.0502C8.54545 12.0502 9 12.4934 9 13.0251Z" fill="#F09D40"/>
      </svg>
    )
  }
}
